import { FC, PropsWithChildren, useCallback } from "react";

import { AppDialog, useDialogState } from "@/hooks/use-dialog-state";

import { ConfirmBlockchainDialog } from "./confirm-blockchain-dialog";
import { CreateVerificationTypeDialog } from "./create-custom-verification-type-dialog";
import { DeleteCMSTabDialog } from "./delete-cms-tab-dialog";
import { DeleteVerificationTypeDialog } from "./delete-custom-verification-type-dialog";
import { DeleteGalleryItemDialog } from "./delete-gallery-item-dialog";
import { DeleteImageDialog } from "./delete-image-dialog";
import { DeleteOrganizationDialog } from "./delete-organization-dialog";
import { DeletePlaylistTrackDialog } from "./delete-playlist-track-dialog";
import { DeleteSKUDialog } from "./delete-sku-dialog";
import { DeleteTagDialog } from "./delete-tag-dialog";
import { DeleteTrackDialog } from "./delete-track-dialog";
import { DeleteVideoDialog } from "./delete-video-dialog";
import { MoveTagsDialog } from "./move-tags-dialog";
import { ResequenceSKUDialog } from "./resequence-sku-dialog";
import { TransferSKUDialog } from "./transfer-sku-dialog";

type Props = PropsWithChildren;

export const DialogManager: FC<Props> = ({ children }) => {
  const { dialog } = useDialogState();

  const renderDialog = useCallback((dialog?: AppDialog) => {
    if (!dialog) {
      return null;
    }

    switch (dialog.name) {
      case "delete-tag":
        return <DeleteTagDialog {...dialog.params} />;
      case "delete-sku":
        return <DeleteSKUDialog {...dialog.params} />;
      case "transfer-sku":
        return <TransferSKUDialog {...dialog.params} />;
      case "resequence-sku":
        return <ResequenceSKUDialog {...dialog.params} />;
      case "confirm-blockchain":
        return <ConfirmBlockchainDialog {...dialog.params} />;
      case "delete-organization":
        return <DeleteOrganizationDialog {...dialog.params} />;
      case "move-tags":
        return <MoveTagsDialog {...dialog.params} />;
      // case "update-video":
      //   return <UpdateVideoDialog {...dialog.params} />;
      case "delete-video":
        return <DeleteVideoDialog {...dialog.params} />;
      // case "update-image":
      //   return <UpdateImageDialog {...dialog.params} />;
      case "delete-image":
        return <DeleteImageDialog {...dialog.params} />;
      case "delete-track":
        return <DeleteTrackDialog {...dialog.params} />;
      case "delete-playlist-track":
        return <DeletePlaylistTrackDialog {...dialog.params} />;
      case "delete-cms-tab":
        return <DeleteCMSTabDialog {...dialog.params} />;
      case "delete-gallery-item":
        return <DeleteGalleryItemDialog {...dialog.params} />;
      case "create-verification-type":
        return <CreateVerificationTypeDialog />;
      case "delete-verification-type":
        return <DeleteVerificationTypeDialog {...dialog.params} />;
      default:
        console.warn("No dialog found for name:", dialog.name);
        return null;
    }
  }, []);

  return (
    <>
      {children}
      {renderDialog(dialog)}
    </>
  );
};
